import React from 'react';
import styles from './CountView.module.scss';
import { generateExpWithNum } from '../../../../../../utils/generateExpWithNum';
import { declensions } from '../../../../../../constants/declensions';
import IndicatorBadge from '../../../../../../components/common/IndicatorBadge/IndicatorBadge';

const CountView = ({
  values = [],
  words = declensions.room,
  isSquare = false,
  isBorder = false,
}) => {
  return (
    <div className={styles.root}>
      {values?.map((value, index) => (
        <div
          className={styles.item}
          key={value.value || index}
        >
          {value?.color && (
            <IndicatorBadge
              bgColor={value.color}
              isSquare={isSquare}
              isBorder={isBorder}
            />
          )}
          <div className={styles.text}>
            <span>{value?.value}</span>
            <span className={styles.count}>
              {generateExpWithNum(value.count, words)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CountView;
